// A drop button points at its inactive link while the drop is not live, when
// it has one.
export const getDropButtonLink = (
	showCardCartButton: boolean,
	button: null | {
		inactive_link?: string | null | undefined;
		link?: string | null | undefined;
	}
) => {
	return !showCardCartButton && button?.inactive_link
		? button.inactive_link
		: button?.link;
};
